export default __webpack_public_path__ + "static/media/leavebottomleft.6e4756e5.svg";